import { fromJS } from 'immutable';

import {ApiDashboard, ApiUrlReportSession, UserToken} from '../../../helper/HelperAuth'
import {GetReportSessionDashboard} from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (body, type=null) => async (dispatch, getState) => {

    const Authorization = UserToken;

    const url = ApiUrlReportSession + 'report-session';

    let query = body

    const argument = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
        },
        body : JSON.stringify(query)
    };

    const response = await doFetch(url,argument);
    let dataResponse = fromJS({});
    let data = fromJS({});
    let responseData = [];
    let finalData = [];
    let datas= []
    if(response.ok){
        dataResponse = fromJS(await response.json());
        data = dataResponse.get('interactive-session');
        if(data != null){
        for (let i = 0; i < data.size; i++) {
            responseData = []
            let dataDetail = data.get(i)
            responseData['date'] = (dataDetail.get('date'))
            responseData['Authentication'] = parseInt(dataDetail.get('authentication'))
            responseData['Marketing'] = parseInt(dataDetail.get('marketing'))
            responseData['Utility'] = parseInt(dataDetail.get('utility'))
            responseData['Service'] = parseInt(dataDetail.get('service'))
            responseData['Total Conversation'] = parseInt(dataDetail.get('total-conversation'))
            finalData.push(responseData)
        }

        let dataTotalAuthentication = dataResponse.get('total-authentication');
        let dataTotalMarketing = dataResponse.get('total-marketing');
        let dataTotalUtility = dataResponse.get('total-utility');
        let dataTotalService = dataResponse.get('total-service');
        let dataTotalConversation = dataResponse.get('total-all-conversation');

        datas['chart'] = finalData
        datas['total-authentication'] = dataTotalAuthentication
        datas['total-marketing'] = dataTotalMarketing
        datas['total-utility'] = dataTotalUtility
        datas['total-service'] = dataTotalService
        datas['total-total-conversation'] = dataTotalConversation
        data = datas

        console.log(data)
    }
}

    dispatch({ type: GetReportSessionDashboard, data:data });
    return data

}